<ng-container *transloco="let t; read: 'findMyAgent.results.contact'">
  @if (showMarketReport) {
    <a
      class="!hidden md:!inline-flex"
      [href]="'/reports/agentmarketreport/' + profileCode"
      target="_blank"
      mat-stroked-button
      color="primary"
      data-id="findMyAgent-market-report">
      <rma-icon glyph="description" />
      <span>{{ t('market-report') }}</span>
    </a>
  }

  @if (isMobile) {
    <a
      class="lg:!hidden"
      [href]="phone | smsUrl: t('sms-message', { name })"
      [rmaClixel]="trixelUrl"
      [sourceCategory]="contactAnalytics.trixelsSmsMadeCategory"
      mat-stroked-button
      color="primary"
      data-id="findMyAgent-contact-sms">
      <rma-icon glyph="message" />
      <span>{{ t('sms') }}</span>
    </a>
  }

  @if (email) {
    <button (click)="contact.emit()" type="button" mat-stroked-button color="primary" data-id="findMyAgent-contact-email">
      <rma-icon glyph="mail" />
      <span>{{ t('email') }}</span>
    </button>
  }

  @if (phone) {
    <rma-agent-phone-link
      class="grow"
      [agentCode]="profileCode"
      [phone]="phone"
      [trixelUrl]="trixelUrl"
      [revealAction]="contactAnalytics.analyticsActionRevealPhone"
      [revealLabel]="contactAnalytics.analyticsLabelRevealPhone"
      [callMadeAction]="contactAnalytics.analyticsActionCallMade"
      [callMadeLabel]="contactAnalytics.analyticsLabelCallMade"
      [trixelRevealCategory]="contactAnalytics.trixelsRevealPhoneCategory"
      [trixelCallCategory]="contactAnalytics.trixelsCallMadeCategory"
      buttonType="flat" />
  }
</ng-container>
